module.exports = __webpack_public_path__ + "resources/img/sp_marketplace.0f6242de490559a887c692bcee8ebd6d.png";